import styled from 'styled-components';

export const StyledInputContainer = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
  
  flex: 1;
`;
